import * as React from "react";
import Alert from "@mui/material/Alert";
import { Collapse, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

const BannerAlertCopy = ({ show, setShow, type, message, width="100%",disableClose=false }) => {

  const getBackgroundColor = (severity) => {
    switch (severity) {
      case 'success':
        return '#9ECDB5'; 
      case 'error':
        return '#E1B0A8';
      case 'info':
        return '#9FCAD6'; 
      case 'warning':
        return '#E2D79D';
      default:
        return '#E0C5C0';
    }
  };

  return (
    <Collapse in={show} sx={{width:width}} >
      <Alert
        severity={type}
        sx={{
          backgroundColor: getBackgroundColor(type),
          ".MuiAlert-action":{
            paddingTop:"0px"
          }
        }}
        className="mt-1 mb-1 d-flex align-items-center"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setShow(false);
            }}
          >
            {!disableClose && <CloseIcon sx={{fontSize:"19px" ,color:"black"}} />}
          </IconButton>
        }
        iconMapping={{
          success: <CheckCircleIcon fontSize="inherit" />,
          error: <ErrorIcon fontSize="inherit" />,
          info: <InfoIcon fontSize="inherit" />,
          warning: <WarningIcon fontSize="inherit" />,
        }}
      >
        {message}
      </Alert>
    </Collapse>
  );
};

export default BannerAlertCopy;
